import { render, staticRenderFns } from "./ParentPageMenuItem.vue?vue&type=template&id=54ed1378&scoped=true&"
import script from "./ParentPageMenuItem.vue?vue&type=script&lang=js&"
export * from "./ParentPageMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./ParentPageMenuItem.vue?vue&type=style&index=0&id=54ed1378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ed1378",
  null
  
)

export default component.exports